import React from 'react';
import { StyleSheet, Text } from 'react-native';
import { COLORS } from '../../styles/colors';
import { fontFamilies } from '../../utils/fontLoader';

/**
 * A reusable heading component with predefined styles for different levels.
 * @param {object} props - The component props.
 * @param {'h1' | 'h2' | 'h3'} [props.level='h2'] - The heading level to apply styles for.
 * @param {React.ReactNode} props.children - The text content of the heading.
 * @param {object} [props.style] - Additional custom styles to apply.
 * @returns {JSX.Element}
 */
const Heading = ({ level = 'h2', children, style, ...props }) => {
  const textStyle = [styles.base, styles[level], style];

  return (
    <Text style={textStyle} {...props}>
      {children}
    </Text>
  );
};

const styles = StyleSheet.create({
  base: {
    color: COLORS.textPrimary,
  },
  h1: {
    fontFamily: fontFamilies.satoshi.bold,
    fontSize: 64,
    lineHeight: 64 * 1.4,
  },
  h2: {
    fontFamily: fontFamilies.satoshi.medium,
    fontSize: 40,
    lineHeight: 40 * 1.4,
  },
  h3: {
    fontFamily: fontFamilies.satoshi.medium,
    fontSize: 28,
    lineHeight: 28 * 1.4,
  },
});

export default Heading;
